export const PathSuperType = 'Path';
export const PathRanks = ['Aspiring', 'Elite', 'Mighty', 'Legendary'];
